import { TABLE_VIEW_TYPES } from '@/components/rangePlan/constants';

const ViewDropdown = ({
	onSelectTargetCol,
	onSelectAchievedCol,
	isShowTarget,
	isShowAchieved,
	detailsView,
	summaryView,
	onTableView
}) => {
	return (
		<ul className="dropdown-menu dropdown-menu-right shadow-lg show">
			<li className="border-bottom title">
				<p className="regular-14 gray_dark_01 px-3 py-2">Show & hide column</p>
			</li>
			<li>
				<div className="custom-chekbox px-3 py-2">
					<div className="form-group mb-0">
						<input
							id="achieved"
							name="achieved"
							type="checkbox"
							checked={isShowAchieved}
							value={isShowAchieved}
							onChange={onSelectAchievedCol}
							disabled={isShowAchieved && !isShowTarget}
						/>
						<label className="regular-14" htmlFor="achieved">
							<span className="gray_dark_01 d-inline regular-14">Achieved</span>
						</label>
					</div>
				</div>
			</li>
			<li>
				<div className="custom-chekbox px-3 py-2">
					<div className="form-group mb-0">
						<input
							id="target"
							name="target"
							type="checkbox"
							value={true}
							checked={isShowTarget}
							onChange={onSelectTargetCol}
							disabled={isShowTarget && !isShowAchieved}
						/>
						<label className="regular-14" htmlFor="target">
							<span className="gray_dark_01 d-inline regular-14">Target</span>
						</label>
					</div>
				</div>
			</li>
			<li className="border-bottom title">
				<p className="regular-14 gray_dark_01 px-3 py-2">Table view</p>
			</li>
			<li>
				<div className="custom-radio px-3 py-2">
					<div className="form-group">
						<input
							type="radio"
							id="details-view"
							value={detailsView}
							name="table-view"
							checked={detailsView}
							onChange={() => onTableView(TABLE_VIEW_TYPES.DETAILS_VIEW)}
						/>
						<label htmlFor="details-view" className="m-0">
							Details view
						</label>
					</div>
				</div>
			</li>
			<li>
				<div className="custom-radio px-3 py-2">
					<div className="form-group">
						<input
							type="radio"
							id="summary-view"
							value={summaryView}
							name="table-view"
							checked={summaryView}
							onChange={() => onTableView(TABLE_VIEW_TYPES.SUMMARY_VIEW)}
						/>
						<label htmlFor="summary-view" className="m-0">
							Summary view
						</label>
					</div>
				</div>
			</li>
		</ul>
	);
};

export default ViewDropdown;
